import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { getFirestore, doc, getDoc } from 'firebase/firestore';

interface BlockedUserRouteProps {
  children: React.ReactNode;
}

const BlockedUserRoute: React.FC<BlockedUserRouteProps> = ({ children }) => {
  const { currentUser } = useAuth();
  const [isBlocked, setIsBlocked] = useState<boolean | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkUserStatus = async () => {
      if (!currentUser) {
        setLoading(false);
        return;
      }

      try {
        const db = getFirestore();
        const userDoc = await getDoc(doc(db, 'users', currentUser.uid));
        
        if (userDoc.exists()) {
          const userData = userDoc.data();
          setIsBlocked(userData.status === 'blocked');
        } else {
          setIsBlocked(false);
        }
      } catch (error) {
        console.error('Error checking user status:', error);
        setIsBlocked(false);
      } finally {
        setLoading(false);
      }
    };

    checkUserStatus();
  }, [currentUser]);

  // Mostrar loading mientras se verifica el estado
  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-red-50 via-white to-red-100 flex items-center justify-center">
        <div className="animate-spin rounded-full h-16 w-16 border-b-4 border-red-600"></div>
      </div>
    );
  }

  // Si el usuario está bloqueado, redirigir a la página de usuario bloqueado
  if (isBlocked) {
    return <Navigate to="/user-blocked" replace />;
  }

  // Si no está bloqueado, mostrar el contenido normal
  return <>{children}</>;
};

export default BlockedUserRoute; 